import { Search, Package, CreditCard } from "lucide-react";
import { motion } from "framer-motion";
import { useLang } from "@/contexts/LanguageContext";

export default function HowItWorks() {
  const { t } = useLang();
  const STEPS = [
    { number: "01", icon: Search, title: t("how_step1_title"), description: t("how_step1_desc") },
    { number: "02", icon: Package, title: t("how_step2_title"), description: t("how_step2_desc") },
    { number: "03", icon: CreditCard, title: t("how_step3_title"), description: t("how_step3_desc") },
  ];

  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="py-24 md:py-32 bg-[#141414]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="text-center mb-20">
          <span className="text-xs tracking-[0.3em] uppercase text-[#C5A059] font-['Outfit'] font-semibold block mb-4">{t("how_tag")}</span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl sm:text-5xl font-light tracking-tight text-white">{t("how_title")}</h2>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {STEPS.map((step, i) => (
            <motion.div key={step.number} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.15 }} className="relative text-center md:text-left">
              <div className="text-6xl font-['Cormorant_Garamond'] font-light text-[#C5A059]/15 mb-4">{step.number}</div>
              <div className="w-12 h-12 mx-auto md:mx-0 flex items-center justify-center border border-[#262626] bg-[#1A1A1A] mb-5">
                <step.icon size={20} className="text-[#C5A059]" strokeWidth={1.5} />
              </div>
              <h3 className="font-['Outfit'] text-white font-medium text-lg mb-3">{step.title}</h3>
              <p className="text-white/40 font-['Outfit'] font-light text-sm leading-relaxed max-w-xs mx-auto md:mx-0">{step.description}</p>
              {i < STEPS.length - 1 && <div className="hidden md:block absolute top-10 right-0 w-[calc(100%-3rem)] h-[1px] bg-[#262626] translate-x-1/2" />}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
